import React, {useState} from 'react';

import {RenderIf} from '../RenderIf';
import {IoMdCloseCircleOutline} from 'react-icons/io';
import {
  Container,
  Input,
  InputContainer,
  Label,
  SearchResultButton,
  SearchResultPlaceholder,
  SearchResultsContainer,
  SelectedResultAction,
  SelectedResultContainer,
  SelectedResultText,
} from './styles';
import {BaseInput} from './BaseInput';
import { TextInput } from './TextInput';

const SearchResults = ({
  results = [],
  onResultPress = () => {},
  isLoading = false,
  loadingPlaceholder = 'Carregando ...',
  errorMessage,
}) => {
  const renderResults = () => {
    return results?.map(result => {
        
      const onPress = (e) => {
        onResultPress(result);
      }

      return (
        <SearchResultButton key={result?.id} onClick={onPress} onMouseDown={e => e.preventDefault()}>
          {result.text}
        </SearchResultButton>
      );
    })
  }

  const notRenderResult = results?.length === 0 && !isLoading;

  const needRenderResults = results?.length > 0;
  const needRenderLoadingPlaceholder = isLoading;
  const needRenderErrorMessage = !!errorMessage;

  if(notRenderResult) {
    return null;
  }
  
  return (
    <SearchResultsContainer>
      <RenderIf isTrue={needRenderErrorMessage}>
        <SearchResultPlaceholder>{errorMessage}</SearchResultPlaceholder>
      </RenderIf>
      <RenderIf isTrue={needRenderLoadingPlaceholder}>
        <SearchResultPlaceholder>{loadingPlaceholder}</SearchResultPlaceholder>
      </RenderIf>
      <RenderIf isTrue={needRenderResults}>
        {renderResults()}
      </RenderIf>
    </SearchResultsContainer>
  );
}

export function SearchInput({
  label = 'Label',
  placeholder = 'Placeholder',
  value = '',
  onChangeText = () => {},
  isLoading = false,
  loadingPlaceholder = 'Carregando ...',
  errorMessage = '',
  results = [],
  onResultPress = () => {},
  onClearSelectedResultPress = () => {},
  defaultValue = '',
  autoFocus = false,
}) {
  const [selectedResult, setSelectedResult] = useState(null);
  const [isInputFocused, setIsInputFocused] = useState(false);

  const onResultItemPress = (result) => {
    setSelectedResult(result);
    onResultPress(result);
    onChangeText('');
  }

  const onSelectedResultClearPress = () => {
    setSelectedResult(null);
    onClearSelectedResultPress();
    onInputBlur();
  }

  const onInputFocus = () => {
    setIsInputFocused(true);
  }

  const onInputBlur = (e) => {
    setIsInputFocused(false);
  }

  const needRenderResults = value?.length > 0 && isInputFocused;

  const renderResults = () => {
    return (
      <RenderIf isTrue={needRenderResults}>
        <SearchResults
          results={results}
          onResultPress={onResultItemPress}
          isLoading={isLoading}
          loadingPlaceholder={loadingPlaceholder}
          errorMessage={errorMessage}
          isInputFocused={isInputFocused}
        />
      </RenderIf>
    )
  }

  const renderInput = () => {
    return (
      <>
        <TextInput
          onFocus={onInputFocus}
          onBlur={onInputBlur}
          renderBottomElement ={renderResults}
          label={label}
          placeholder={placeholder}
          onChangeText={onChangeText}
          text={value}
          defaultValue={defaultValue}
          autoFocus={autoFocus}
        >

        </TextInput>        
      </>
    );
  }
  
  const renderSelectedResult = () => {
    return (
      <SelectedResultContainer>
        <SelectedResultText>{selectedResult?.text}</SelectedResultText>
        <SelectedResultAction onClick={onSelectedResultClearPress}>
          <IoMdCloseCircleOutline size={'1.2em'}/>
        </SelectedResultAction>
      </SelectedResultContainer>
    );
  }

  return (
    <>
      <RenderIf isTrue={!!selectedResult}>
        {renderSelectedResult()}
      </RenderIf>
      <RenderIf isTrue={!selectedResult}>
        {renderInput()}
      </RenderIf>
    </>
  );
}